var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4132_1246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.6944 18 17.5 14.1944 17.5 9.5C17.5 4.80558 13.6944 1 9 1C4.30558 1 0.5 4.80558 0.5 9.5C0.5 14.1944 4.30558 18 9 18Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.6944 17 17.5 13.1944 17.5 8.5C17.5 3.80558 13.6944 0 9 0C4.30558 0 0.5 3.80558 0.5 8.5C0.5 13.1944 4.30558 17 9 17Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5C12.866 15.5 16 12.366 16 8.5C16 4.63401 12.866 1.5 9 1.5C5.13401 1.5 2 4.63401 2 8.5C2 12.366 5.13401 15.5 9 15.5Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48919 4.24608C9.74013 3.94511 10.2289 4.15079 10.1892 4.5407L9.90888 7.27961H12.1765C12.2519 7.27964 12.3258 7.30116 12.3895 7.34166C12.4531 7.38216 12.5039 7.43995 12.5359 7.50828C12.5679 7.57661 12.5798 7.65263 12.5701 7.72746C12.5605 7.80229 12.5297 7.87282 12.4814 7.93079L8.51084 12.6955C8.2599 12.9965 7.77112 12.7908 7.81083 12.4009L8.09115 9.66196H5.82355C5.7481 9.66194 5.67422 9.64041 5.61057 9.59991C5.54691 9.55942 5.49611 9.50162 5.46411 9.4333C5.43211 9.36497 5.42025 9.28894 5.4299 9.21411C5.43955 9.13929 5.47032 9.06876 5.5186 9.01079L9.48919 4.24608Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4132_1246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.070b23dcca1ee1e146c4416938060f48.svg";
export { ForwardRef as ReactComponent };